import { ManualGasXTransfert } from '@core/models/manual-gasx-transfert.model';
import { createAction, props } from '@ngrx/store';

import { ExportType } from '../models/export-type.enum';
import { ExportGasXSelectionMode } from '../models/selection-mode.model';

export const initData = createAction('[Export GasX] Init data');
export const initDataSuccess = createAction(
  '[Export GasX] Init data success',
  props<{ manualGasXTransfert: ManualGasXTransfert }>()
);
export const initDataError = createAction('[Export GasX] Init data error');

export const resetState = createAction('[Export GasX] Reset state');

export const switchSelectionMode = createAction(
  '[Export GasX] Switch selection mode',
  props<{ selectionMode: ExportGasXSelectionMode }>()
);

export const openSelectObjectPopup = createAction(
  '[Export GasX] Open select object popup',
  props<{ model: Array<{ [index: string]: any }> }>()
);

export const manualGasXTransfert = createAction(
  '[Export GasX] Manual GasX transfert',
  props<{ startDate: string; endDate: string; exportTypes: Array<ExportType>; keys?: Array<string> }>()
);
export const manualGasXTransfertSuccess = createAction('[Export GasX] Manual GasX transfert success');
export const manualGasXTransfertError = createAction('[Export GasX] Manual GasX transfert failure');

export const updateLatestManualGasXTransfert = createAction(
  '[Export GasX] Update manual GasX transfert',
  props<{ manualGasXTransfert: ManualGasXTransfert }>()
);

export const cancelManualGasXTransfert = createAction('[Export GasX] Cancel manual GasX transfert');
export const cancelManualGasXTransfertSuccess = createAction('[Export GasX] Cancel manual GasX transfert success');
export const cancelManualGasXTransfertError = createAction('[Export GasX] Cancel manual GasX transfert failure');

export const setSelectedObjects = createAction(
  '[Export GasX] Set selected objects',
  props<{ selectedObjects: Array<string> }>()
);
